import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { getOrCreateBootstrap, hasCompletedBootstrap } from './bootstrap-promise';
import { prepararDatosLocales } from '@/lib/bootstrap';
import { getOrCreateRoot } from './react-root';
import '@mibodega/i18n';
import { initTheme } from '@/lib/theme';
import './styles/index.css';

initTheme();

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element #root not found in DOM');
}

const root = getOrCreateRoot(rootEl, (container) => ReactDOM.createRoot(container));

/**
 * El arranque en frío de un equipo lento no puede quedar en blanco sin
 * explicación mientras corre la migración a IndexedDB. Texto fijo a propósito:
 * esto pinta antes de que i18n resuelva su bundle.
 */
function Arrancando() {
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex min-h-dvh items-center justify-center px-6 text-center text-sm text-neutral-600"
    >
      Preparando los datos de este equipo…
    </div>
  );
}

if (!hasCompletedBootstrap()) {
  root.render(<Arrancando />);
}

// El render de la app espera a la migración: montar antes deja que el
// indicador de sync y la carga de catálogo peguen contra IndexedDB con la
// transacción de migración abierta. Cuesta una transacción en el primer
// arranque y nada después. `prepararDatosLocales` no lanza: si algo falló,
// queda publicado como problema y la app monta igual.
void getOrCreateBootstrap(prepararDatosLocales).then(() => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
});
